import { interpalateColor } from '../../utils/colorUtils';
import StyleFactory from '../../StyleFactory';
export const themeSelector = (value, theme, _feature, _resolution, _params, _viewOptions, view) => {
  let pressure = value;
  let color;
  const themeOption = view === "area" ? theme.color.area : theme.color.default;
  if (pressure < theme.min) pressure = theme.min;
  if (pressure > theme.max) pressure = theme.max;

  if (pressure < 980) {
    color = interpalateColor(themeOption.lowStart, themeOption.low, (pressure - theme.min) / 80);
  } else if (pressure < 1010) {
    color = interpalateColor(themeOption.low, themeOption.lowEnd, (pressure - 980) / 30);
  } else if (pressure < 1015) {
    color = themeOption.highStart;
  } else if (pressure < 1050) {
    color = interpalateColor(themeOption.highStart, themeOption.high, (pressure - 1015) / 35);
  } else {
    color = interpalateColor(themeOption.high, themeOption.highEnd, (pressure - 1050) / 50);
  }

  return {
    color
  };
};
export default {
  grid: StyleFactory.createDefaultGridStyle(themeSelector),
  line: StyleFactory.createDefaultIsolineStyle(themeSelector),
  area: StyleFactory.createDefaultAreaStyle(themeSelector)
};